import { useState,useEffect } from 'react';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import { sendRequest } from '../requests/useRequest';
import { useForm } from '../forms/useForm';
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom';
import {validateAuthorization} from '../../services/microsanitaria/reception'



export const useMicroReception = () => {

    const { _nim } = useParams();

    
    const [createSweet] = useSweetAlert();
    const [showDetails, setShowDetails] = useState(false);
    const [age, setAge] = useState("");
    const [curp, setCurp] = useState("")
    const [phone, setPhone] = useState("")
    const [gender, setGender] = useState(0);
    const [datanim, setDatanim] = useState(0);
    const [namepatien, setNamepatien] = useState("");
    const [maternal_surname, setMaternalSurname] = useState("");
    const [paternal_surname, setPaternalSurname] = useState("");
    const [code, setCode] = useState("");
    const [samples, setSamples] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSample, setSelectedSample] = useState(null);
    const [thermometers, setThermometers] = useState([]);
    const [containers, setContainer] = useState([]);
    const [reasons, setReasons] = useState([]);
    const [units, setUnits] = useState([]);
    const [status, setStatus] = useState([]);
    const [comments, setComments] = useState("");
    const [rangeTemperature, setRangeTemperature] = useState([]);
    const idBranch = localStorage.getItem("branchId");
    let nameBranch = localStorage.getItem('branchName')
    const history = useHistory();
    const [characteristic, setCharacteristic] = useState([])

    const [isModalAuthorization, setIsModalAuthorization] = useState(false);
    const [password, setPassword] = useState('')
    const [invalidPasword, setInvalidPasword] = useState(false)
    const [messageInvalid, setMessageInvalid] = useState("")



    const handleOpenModal = (sample) => 
    {
        setSelectedSample(sample);
        setIsModalOpen(true);
    };


    const handleCloseModal = () => 
    {
        setSelectedSample(null);
        setIsModalOpen(false);
    };


    const handleOpenModalAuthorization = (sample) => 
    {
        setSelectedSample(sample);
        setIsModalAuthorization(true);
    };
    

    const handleCloseModalAuthorization = () => 
    {
        setSelectedSample(null);
        setIsModalAuthorization(false);
        setInvalidPasword(false)
        setMessageInvalid("")
        setPassword('');
    };

    useEffect(() => {
        if (_nim !== undefined && parseInt(_nim) > 0) {
            getDataSamplePost();    
        }
      
    }, [_nim])
    

    const [formNim, handleInputChangeNim, resetForm] = useForm({
        nim: "",
    });
    const { nim } = formNim;
    const checkNim = (e) => {
        e.preventDefault();

       

        if (formNim.nim.length > 0) {
            getDataSamplePost();
        }
        else {
            createSweet("info", "info", "Atención", "Debes de ingresar un NIM válido");
            return;
        }
        
    }
    const getDataSamplePost = async () => {

        let _valid = _nim === undefined ? nim : parseInt(_nim)

        let response = await handleRequest("POST", "TrackingMicro/GetSampleMicro", "Sample", { nim: _valid });

        if (response !== null) {
            if (!response.is_micro) {
                createSweet("info", "info", "Atención", "Este NIM no corresponde a microsanitaria.");
                return;
            }

            if (response !== null) {
                setShowDetails(true);
                setCurp(response.curp);
                setPhone(response.phone);
                setNamepatien(response.name);
                setPaternalSurname(response.paternal_surname);
                setMaternalSurname(response.maternal_surname);
                setCode(response.code);
                setDatanim(response.nim);
                setSamples(response.samples);
                setThermometers(response.thermometers);
                setContainer(response.containers);
                setStatus(response.status);
                setComments(response.comments);
                setReasons(response.reasons);
                setRangeTemperature(response.rangeTemperature);
                setUnits(response.units);
                setCharacteristic(response.characteristics)
            }
        }
    }

    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {

            return response.data;

        }
        else if (response.code === 409) {
            createSweet("info", "info", "Atención", response.data.msg);
        }
        else if (response.code === 500) {
        }
        else {
        }
        return null;
    }

    const handleCloseViewSend = () => {
        setShowDetails(false);
        resetForm();
    }
    

    const handleChangeMic = (e, id_mic_detail_sample) => 
    {
        const { name, value } = e.target;

        setSamples((prevSamples) =>
            prevSamples.map((s) => {
                if (s.id_mic_detail_sample !== id_mic_detail_sample) return s;

                let updatedSample = { ...s, [name]: value };

                if (name === 'id_thermometer_send') {
                    const selectedIdThermometer = parseInt(value, 10);
                    const selectedThermometer = thermometers.find(
                        t => t.id_thermometer === selectedIdThermometer
                    );
                    const correctionFactor = selectedThermometer?.correction_factor ?? null;

                    if (s.temperature_send && !isNaN(parseFloat(s.temperature_send)) && correctionFactor !== null) {
                        const _temperature = parseFloat(s.temperature_send);
                        const _sumCorrection = parseFloat((_temperature + correctionFactor).toFixed(1));
                        updatedSample.temperature_corrected_send = _sumCorrection;
                    }

                    updatedSample[name] = selectedIdThermometer;
                }

                if (name === 'temperature_send') {
                    const tempValue = parseFloat(value);
                    const thermometer = thermometers.find(t => t.id_thermometer === parseInt(s.id_thermometer_send));

                    if (!isNaN(tempValue) && thermometer?.correction_factor !== undefined) {
                        const _sumCorrection = parseFloat((tempValue + thermometer.correction_factor).toFixed(1));
                        updatedSample.temperature_corrected_send = _sumCorrection;
                    }
                }

                return updatedSample;
            })
        );
    };
  

    const saveMicDetailSend = async (idMicDetailSample) => {

        const sampleToSave = samples.find(sample => sample.id_mic_detail_sample === idMicDetailSample);


        if (!sampleToSave) {
            createSweet("error", "error", "Error", "No se encontró la muestra seleccionada.");
            return;
        }
        const data = {
            id_mic_detail_sample: sampleToSave.id_mic_detail_sample,
            temperature_send: sampleToSave.temperature_send || "",
            mark_and_lot_send: sampleToSave.mark_and_lot_send || "",
            id_thermometer_send: sampleToSave[`id_thermometer_send`] || "",
            id_container_send: sampleToSave[`id_container_send`] || "",
            temperature_corrected_send: sampleToSave.temperature_corrected_send || "",
            quantity_send: sampleToSave.quantity_send || "",
            comply_temperature_send: sampleToSave.comply_temperature_send || "",
            comments: sampleToSave.comments || "",

        };

        const response = await handleRequest("POST", "TrackingMicro/SaveSampleDetail", "Guardar muestra", data);

        if (response !== null) {
            //createSweet("success", "success", "Éxito", "La muestra fue guardada correctamente.");
        }

        if (response !== null) {
            const trackingData = {
                id_work_order: sampleToSave.id_work_order,
                id_mic_detail_sample: sampleToSave.id_mic_detail_sample,
                id_mic_status: sampleToSave[`id_mic_status`],
                id_branch: idBranch,
                id_section: sampleToSave.id_section,
                id_return_reason: sampleToSave[`id_return_reason`],
                id_mic_cat_units: sampleToSave[`id_mic_cat_units`],
                id_characteristic_send: sampleToSave[`id_characteristic_send`] || "",

            };

            const responseTracking = await handleRequest("POST", "TrackingMicro/SaveTrackingMicro", "Guardar status", trackingData);

            if (responseTracking !== null) {
                await getDataSamplePost();
                createSweet("success", "success", "Éxito", "Los datos fueron guardados correctamente");
                handleCloseModal();

            } else {
                createSweet("warning", "warning", "Parcial", "La muestra fue guardada, pero ocurrió un error al guardar el status.");
            }
        }
    };

    const navigateQuoter = () => 
    {
        history.push(`../../sanitaria/cotizacion`);
    }


    const saveValidate = async (_id_mic_detail_sample) => 
    {
        if (password ==='') {
            setInvalidPasword(true)
            setMessageInvalid("Debe de ingresar su acceso para poder autorizar una edición")
            return;         
        }
   

        const response = await validateAuthorization({
            accessUser: password,
            id_mic_detail_sample: _id_mic_detail_sample,   
        });

        if (response.code === 200) {
            handleCloseModalAuthorization()
            setPassword('')
            getDataSamplePost();
            setInvalidPasword(false)
            setMessageInvalid("")
        }
        else {
            setPassword('')
            setInvalidPasword(true)
            setMessageInvalid(response.msg)

        }
    }

    






    return {
        checkNim,
        handleInputChangeNim,
        formNim,
        showDetails,
        handleCloseViewSend,
        gender,
        namepatien,
        age,
        curp,
        phone,
        gender,
        paternal_surname,
        maternal_surname,
        code,
        datanim,
        samples,
        isModalOpen,
        selectedSample,
        handleOpenModal,
        handleCloseModal,
        thermometers,
        containers,
        handleChangeMic,
        saveMicDetailSend,
        status,
        getDataSamplePost,
        reasons,
        rangeTemperature,
        units,
        nameBranch,
        _nim,
        navigateQuoter,
        characteristic,
        handleOpenModalAuthorization,
        handleCloseModalAuthorization,
        isModalAuthorization,
        password,
        setPassword,
        saveValidate,
        invalidPasword,
        messageInvalid,


    };

}


